import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

type LimitReachedCommunicateProps = {
  className?: string;
};

export const LimitReachedCommunicate = ({ className }: LimitReachedCommunicateProps) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge("mx-auto max-w-xl rounded-lg border border-base-300 bg-muted p-8", className)}>
      <h2 className="mb-6 text-center font-serif text-3xl">{t(`cmsTranslations.limit_reached.title`)}</h2>
      <p className="text-center">{t(`cmsTranslations.limit_reached.description`)}</p>
    </div>
  );
};
